import { ViewObjectContainerSaveableSettingsProvider } from "./view-object-container-saveable-settings-provider";

export class ColumnGridSaveableSettingsProvider extends ViewObjectContainerSaveableSettingsProvider {
  constructor(viewObjectProviders) {
    super(viewObjectProviders);
  }

  createSaveableSettings(settings) {
    if (settings.columns === undefined) {
      return {
        columns: []
      };
    }
    const parsedColumns = [];
    for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
      const columnSettings = settings.columns[columnIndex];
      const columnInfo = {
        rows: []
      };
      for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
        const itemSettings = this.createItemSettings(columnSettings.rows[rowIndex].item);
        columnInfo.rows.push({
          item: itemSettings
        });
      }
      parsedColumns.push(columnInfo);
    }
    return {
      columns: parsedColumns
    };
  }

  applySaveableSettings(settings, saveableSettings) {
    if (
      settings.columns === undefined ||
      saveableSettings.columns === undefined ||
      settings.columns.length != saveableSettings.columns.length
    ) {
      return;
    }
    for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
      const columnSettings = settings.columns[columnIndex];
      const saveableColumnSettings = saveableSettings.columns[columnIndex];
      if (
        columnSettings.rows !== undefined &&
        saveableColumnSettings.rows !== undefined &&
        columnSettings.rows.length == saveableColumnSettings.rows.length
      ) {
        for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
          this.applyItemSettings(columnSettings.rows[rowIndex].item, saveableColumnSettings.rows[rowIndex].item);
        }
      }
    }
  }
}
